import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import _ from "lodash";

export default function BottomBar() {
  const socialMediaLinks = [
    { website: "LinkedIn", url: "https://www.linkedin.com/company/ini-farms/" },
    { website: "Instagram", url: "https://www.instagram.com/kimaye_ini/" },
    { website: "Website", url: "https://www.kimaye.com/" },
  ];
  return (
    <Box sx={{ marginTop: 4, marginBottom: 2 }}>
      <Grid container justifyContent={`center`} spacing={2}>
        {_.map(socialMediaLinks, (socialMediaLink) => (
          <Grid item>
            <a href={socialMediaLink.url} target={`_blank`}>
              <Box sx={{ textAlign: "center" }}>
                <img
                  src={`/${socialMediaLink.website}.svg`}
                  alt={``}
                  height={50}
                  width={50}
                />
              </Box>
            </a>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
